<template>
  <v-text-field
    v-if="showItem"
    :label="item.label"
    v-model="item.value"
    :rules="rulesValidation"
    :maxlength="item.maxlength ? item.maxlength: 1000"
    :disabled="disabled || item.readonly"
    :persistent-hint="!localItem"
    hint="E' possibile cercare la pubblica amministrazione dal Codice Fiscale"
    :error="codiceError"
    :error-messages="codiceError ? errorMessage : ''"
    :loading="verificaInCorso"
    @change=onChange>
    <template v-slot:append-outer>
      <v-icon color="success" @click="companyInformation" title="Cerca la PA">mdi-account-search-outline</v-icon>
    </template>
  </v-text-field>
</template>

<script>
  import clienti from '@/services/clientiService.js'
  import { validazioni } from '@/mixins/validazioni.js'

  export default {
    name: 'barcode',
    mixins: [
      validazioni
    ],
    props: {
      item: Object,
      appoggio: Object,      
      disabled: { type: Boolean, default: false },
      updateTrigger: Number
    },
    data: (vm) => ({
      localItem: vm && vm.item ? vm.item.value : '',
      codiceError: false,
      verificaInCorso: false,
      errorMessage: ''
      // originalValue: vm && vm.item && vm.item.value ? JSON.parse(JSON.stringify(vm.item.value)) : ''
/*       rules: {
        required: value => !!value || 'Campo richiesto.',
        counter: value => value.length <= vm.item.maxlength || `Max ${vm.item.maxlength} caratteri`
      } */
    }),
    mounted() {
      // this.originalValue = this.item && this.item.value ? JSON.parse(JSON.stringify(this.item.value)) : ''
    },
    watch: {
      showDrawer(value) {
/*         if (value && this.item && this.item.value) {
          this.originalValue = JSON.parse(JSON.stringify(this.item.value))
        } */
      }
    },
    computed: {
      showDrawer() {
        return this.$store.getters.rightDrawer
      },
      showItem() {
        if (!this.updateTrigger) { }
        if (this.item && this.item.showIf) {
          return _.get(this, this.item.showIf, false)
        } else if (this.item && this.item.hideIf) {
          return !_.get(this, this.item.hideIf, false)
        } else {
          return true
        }
      }
    },
    methods: {
      async companyInformation() {
        if (this.item.value.length === 0) {
          this.codiceError = true
          this.errorMessage = `Per cercare la PA è necessario inserire il Codice Fiscale (11 char)`
          return
        }
        const tipoAzienda = 'pa'
        let info = await clienti.companyV2Information(this.item.value, tipoAzienda)
        if (!info) {
          this.codiceError = true
          this.errorMessage = 'Si è verificato un errore nella richiesta'
        } else if (info.message) {
          this.codiceError = true
          this.errorMessage = info.message
        } else {
          this.$emit('change', { azienda: info.azienda })
        }
      },
      async onChange(value) {
        if (value) {
          this.codiceError = false
          this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value })
/*           this.verificaInCorso = true
          const result = await prodotti.verificaBarcodeValido(value)
          this.verificaInCorso = false
          if (result.status === 'ok' || (result.status === 'error' && this.originalValue === value)) {
            this.codiceError = false
            this.item.value = value
            this.$emit('change', { model: this.item.model, subModel: this.item.subModel, value })
          } else {
            this.codiceError = true
            this. errorMessage = result.error
          } */
        }
      }
    }
  }
</script>